if (!customElements.get('cart-upsell-item')) {
  customElements.define(
    'cart-upsell-item',
    class CartUpsellItem extends HTMLElement {
      constructor() {
        super();
      }

      connectedCallback() {
        this.quantitySelector = this.querySelector('select[name="quantity"]');
        this.submitBtn = this.querySelector('button.cart-upsell-item__submit');
        this.cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
        this.compareAtPrice = this.querySelector('.cart-upsell-item__price s');
        this.price = this.querySelector('.cart-upsell-item__price p');

        this.quantitySelector.addEventListener('change', this.onQuantityChange.bind(this));
        this.submitBtn.addEventListener('click', this.onSubmitBtnClick.bind(this));
      }

      onQuantityChange() {
        const opt = this.quantitySelector.options[this.quantitySelector.selectedIndex];
        this.price.textContent = opt.dataset.price;
        if (opt.dataset.compareAtPrice) {
          this.compareAtPrice.textContent = opt.dataset.compareAtPrice;
        } else {
          this.compareAtPrice.textContent = '';
        }
      }

      onSubmitBtnClick() {
        this.classList.add('is-loading');

        const body = JSON.stringify({
          items: [{
            id: this.quantitySelector.value,
            quantity: 1,
          }],
          sections: this.cart.getSectionsToRender().map((section) => section.id),
          sections_url: window.location.pathname,
        });

        fetch(`${routes.cart_add_url}`, { ...fetchConfig(), ...{ body } })
          .then((res) => res.json())
          .then((res) => {
            this.cart.renderContents(res);
          })
          .finally(() => {
            this.classList.remove('is-loading');
          })
      }
    },
  );
}
